module.exports = __webpack_public_path__ + "assets/4031235e23c4db0c805392b8b353df1f.json";